import { HomeStatsProps } from "@/common/types"
import { transformKitStatus } from "@/utils/common.util"

const HomeStats: React.FC<HomeStatsProps> = ({ title, value }) => {

    return (
        <div className="w-full h-full flex flex-col border rounded-md">
            <p className="font-bold px-4 pt-4 pb-2 border-b">{transformKitStatus(title)}</p>
            {(Object.keys(value)).map((valueKey) => (
                <div key={valueKey} className="flex items-center gap-2 px-4 py-2">
                    <div className="font-bold">{value[valueKey]}</div>
                    <div>{transformKitStatus(valueKey)}</div>
                </div>
            ))}
        </div>
    )
}

export default HomeStats
